import { forwardRef } from 'react';

interface Props extends React.InputHTMLAttributes<HTMLInputElement> {
  label: string;
  id: string;
  error?: string;
  isDirty?: boolean;
}

type Ref = HTMLInputElement;

const Checkbox = forwardRef<Ref, Props>(
  ({ error, id, isDirty, label, ...props }, ref) => {
    return (
      <div className="relative flex items-center">
        <div className="flex items-center">
          <input
            ref={ref}
            id={id}
            type="checkbox"
            className="h-5 w-5 rounded border-blue-400 text-blue-400 focus:ring-0 focus-visible:outline-blue-800"
            {...props}
          />
        </div>
        <label htmlFor={id} className="ml-3 text-15 leading-140 text-blue-800">
          {label}
        </label>
        {error && (
          <div className="text-error text-11 px-7 pt-1 font-medium">
            {error}
          </div>
        )}
      </div>
    );
  },
);

Checkbox.displayName = 'Checkbox';

export default Checkbox;
